// src/hooks/useRefreshToken.tsx
import axios from "../api/axios";
import useAuth from "./useAuth";
import { useNavigate, useLocation } from "react-router-dom";

// Dynamically construct the refresh URL based on current host
const getRefreshUrl = () => {
	if (import.meta.env.MODE !== "development") {
		return "https://property.nbalma.gr/api/nb/refresh";
	}
	// In development, use the current host
	const currentHost = window.location.hostname;
	const apiPort = 5875; // Your API port
	return `http://${currentHost}:${apiPort}/api/nb/refresh`;
};

const useRefreshToken = () => {
	const { setAuth } = useAuth() as { setAuth: any };
	let isRefreshing = false;
	const navigate = useNavigate();
	const location = useLocation();

	const refresh = async () => {
		if (isRefreshing) {
			// Already refreshing
		}
		isRefreshing = true;
		try {
			const REFRESH_URL = getRefreshUrl();
			const response = await axios.get(REFRESH_URL, {
				withCredentials: true,
			});
			setAuth((prev: any) => ({
				...prev,
				accessToken: response.data.accessToken,
				user: response.data.email,
			}));
			return response.data.accessToken;
		} catch (error) {
			console.error("Error refreshing token:", error);
			navigate("/login", { state: { from: location }, replace: true });
			throw error;
		} finally {
			isRefreshing = false;
		}
	};
	return refresh;
};

export default useRefreshToken;